import { PermissionT } from "../types";

export const platformCommunications = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "platform_communications");
  return !!p;
};

export default platformCommunications;
